export default "__VITE_ASSET__ff41224b__"